import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { CopyIcon, User2Icon } from 'lucide-react'

import { getCLICodeInExchangeForApp } from '~/dataProcessor/api/api'
import { DialogBoxCenter } from '~/design-system/atom/alert-dialog-sheet'
import { DialogDescription, DialogHeader } from '~/design-system/atom/dialog'
import { Input } from '~/design-system/atom/input'
import { toast } from '~/design-system/atom/use-toast'
import { scrollBarStyle } from '~/ui/constants/style/common'
import { copyText } from '~/utils/dom'
import { RightSideContent } from '../../containers/base/base'
import { ToolkitList } from './appListContainer'

export const isCLIKeyActive = () => {
  return localStorage.getItem('cliKey') !== null
}

export const ShowCLIKeyOverlay = () => {
  const [cliKey, setCliKey] = useState<string | null>(null)
  const [accessCode, setAccessCode] = useState<string | null>(null)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const cliKey = JSON.parse(localStorage.getItem('cliKey') ?? '{}')

    if (cliKey && cliKey.expiry > new Date().getTime()) {
      getCLICodeInExchangeForApp({
        key: cliKey.value,
      }).then((res) => {
        setAccessCode(res.cliCode)
        setCliKey(cliKey.value)
      })
    }
  }, [])

  if (!cliKey) {
    return null
  }

  return (
    <DialogBoxCenter
      open={!!cliKey}
      setOpen={(open) => {
        if (open === false) {
          localStorage.removeItem('cliKey')
          setCliKey(null)
        }
      }}
      className={clsx(
        ' max-h-[90vh] min-w-[580px] overflow-y-scroll bg-white text-black-200 ',
        scrollBarStyle,
      )}
    >
      <DialogHeader>
        <div
          className="diplay-flex  text-[17px] font-[500] leading-none tracking-[.35px] "
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <User2Icon
            className="ml-1 h-[24px] w-[24x] cursor-pointer p-1"
            onClick={(e) => {
              e.stopPropagation()
              copyText(cliKey)
              toast({
                title: 'Success',
                description: 'CLI key has been copied to your clipboard',
              })
            }}
          />
          CLI Key
        </div>
        <span className="mt-4 font-gilroy text-[13px] tracking-[.35px]">
          Copy and paste the following code into your terminal to complete the
          setup:
        </span>
      </DialogHeader>
      <DialogDescription>
        <Input
          className="flex h-[40px] w-full items-center justify-between rounded-[12px] border px-3 py-2 outline-none"
          ref={inputRef}
          value={accessCode!}
          rightIcon={
            <CopyIcon
              className="cursor-pointer"
              onClick={() => {
                copyText(accessCode!, inputRef.current)
                toast({
                  title: 'Success',
                  description: 'Access code has been copied to your clipboard',
                })
              }}
              size={14}
            />
          }
        />
      </DialogDescription>
    </DialogBoxCenter>
  )
}

export default function AppScreen() {
  return (
    <RightSideContent
      header={
        <div className="w-full">
          <span className="min-w-[120px]">Tools</span>
        </div>
      }
      className="!bg-[#fff]"
    >
      <ToolkitList />
    </RightSideContent>
  )
}
